module.exports = __webpack_public_path__ + "static/media/bp-logo.5cf62c0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bp-logo.svg
// module id = 485
// module chunks = 0